import "./TextArea.scss"

interface TextAreaProps {
  id: string
  name?: string
  onChange: (value: string) => void
  value: string
  labelText?: string
  placeholder?: string
  rows?: number
}

export const TextArea: React.FC<TextAreaProps> = ({
  id,
  name,
  onChange,
  value,
  labelText,
  placeholder,
  rows = 5,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(event.target.value)
  }

  return (
    <div className="text-area-container">
      {labelText && (
        <label htmlFor={id} className="label">
          {labelText}
        </label>
      )}
      <textarea
        id={id}
        name={name}
        className="text-area"
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        rows={rows}
      />
    </div>
  )
}
